export const title = 'Ingresa';
export const emailLabel = 'Email';
export const emailWarning = 'Por favor ingresa un email válido';
export const passwordLabel = 'Contraseña';
export const passwordWarning = 'Por favor ingresa tu contraseña';
export const logInButton = 'Ingresa';
export const forgotPasswordButton = '¿Olvidaste tu contraseña?';
